import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import WizardItem from "./WizardItem/WizardItem";

const WizardSetupList = (props) => {

  const {wizardList, wizardListReceived, wizardVisualizer, fabricatorSubscriptions, fabricatorSubscriptionsReceived} = props;

  if (!wizardListReceived || !fabricatorSubscriptionsReceived) {
    return (
      <div style={{height: "200px"}}>
        <div className="ui-loader"/>
      </div>
    )
  }

  if (!fabricatorSubscriptions.length) {
    return (
      <div className="wizard-no-items">
        <FormattedMessage id="wizard.noFabricatorSubscriptions"/>
      </div>
    )
  }

  const currentWizardList = wizardList.filter(wizardItem => wizardItem.visualizer === wizardVisualizer);

  if (!currentWizardList.length) {
    return (
      <div className="wizard-no-items">
        <FormattedMessage id="wizard.noWizardsCreated"/>
      </div>
    )
  }

  return (
    <ul className="wizard-list">
      {currentWizardList.map((wizardItem, wizardItemIndex) => <WizardItem wizardItem={wizardItem} key={"wizard" + wizardItemIndex}/>)}
    </ul>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardListReceived, wizardVisualizer} = store.wizardState;
  const {fabricatorSubscriptions, fabricatorSubscriptionsReceived} = store.newScope;

  return {
    wizardList,
    wizardListReceived,
    wizardVisualizer,
    fabricatorSubscriptions,
    fabricatorSubscriptionsReceived,
  };
};

export default connect(mapStateToProps)(WizardSetupList)
